export default __webpack_public_path__ + "static/media/Pilgrim's Bands of the Exalted Spirit.56ce0548.jpg";